<script lang="ts">
import { defineComponent, inject, ref } from 'vue'
import LogoBizHint from '@/components/logo/LogoBizHintDefault.vue'
import { newUserSessionPath } from '@/generated/railsRoutes'

export default defineComponent({
  name: 'FollowSnsForFooter',

  components: {
    LogoBizHint,
  },

  setup() {
    // constants
    const EXTERNAL_URL = inject<Record<string, string>>('EXTERNAL_URL')

    const followService = ref({
      melmaga: {
        to: newUserSessionPath(),
        isTargetBlank: false,
      },
      facebook: {
        to: EXTERNAL_URL!.bizhint_facebook_url,
        isTargetBlank: true,
      },
      twitter: {
        to: EXTERNAL_URL!.bizhint_twitter_url,
        isTargetBlank: true,
      },
    })

    return {
      // data
      followService,
    }
  }
})
</script>

<template>
  <section class="f-section__fowllowSns">
    <div class="f-section__fowllowSns--body">
      <div class="l-unit__followSns">
        <div class="l-unit__followSns--header">
          <div class="o-heading__followSns">
            <h2 class="o-heading__followSns--item">
              BizHint（ビズヒント）- クラウド活用と生産性向上の専門サイト
            </h2>
          <!-- /.o-heading__followSns --></div>
        <!-- /.l-unit__followSns header --></div>

        <div class="l-unit__followSns--image">
          <LogoBizHint />
        <!-- /.l-unit__followSns image --></div>

        <div class="l-unit__followSns--description">
          <div class="o-list__followSns">
            <dl class="o-list__followSns--unit">
              <dt class="o-list__followSns--term">
                最新情報はニュースレター・SNSで配信中
              </dt>
              <dd
                v-for="(item, key) in followService"
                :key="key"
                class="o-list__followSns--description">
                <div class="o-action__cta">
                  <a
                    class="o-action__cta--item"
                    :href="item.to"
                    :target="item.isTargetBlank ? '_blank' : '_self'">
                    <i
                      v-if="key === 'melmaga'"
                      :class="[
                        `i-melmaga`,
                        'is-large',
                      ]" />
                    <i
                      v-else
                      :class="[
                        `i-sns__${key}`,
                        'is-large',
                      ]" />
                  </a>
                <!-- /.o-action__cta --></div>
              </dd>
            </dl>
          <!-- /.o-list__followSns --></div>
        <!-- /.l-unit__followSns description --></div>
      <!-- /.l-unit__followSns --></div>
    <!-- f-section__fowllowSns body --></div>
  <!-- f-section__fowllowSns --></section>
</template>

<style lang="sass" scoped>
// foundation
.f-section__fowllowSns
  position: relative
  background-color: rgba($bg-white, 1)
  border-top: 1px solid $border-x-light-gray

  & &--body
    width: 100%
    max-width: #{$global-contents-width-pc}px
    display: flex
    justify-content: center
    margin: 0 auto
    position: relative
    padding: 2em 0 1.5em

  +breakpoint
    display: none

// layout
.l-unit__followSns
  $root: &
  +base-layout($image-position: left, $root: $root, $image-width: 112, $image-height: 0, $margin-size: 48)

  & &--image
    height: 100%
    display: flex
    flex-direction: column
    justify-content: center

// object
.o-heading__followSns
  position: relative
  margin-bottom: 0.7em

  & &--item
    line-height: 1
    color: $font-black
    font:
      size: $font-small
      weight: bold

.o-list__followSns
  & &--unit
    display: flex
    align-items: center

  & &--term
    font-size: $font-small

  $icon-size-px: 22
  & &--description
    width: changeSizePx2Em($icon-size-px)
    margin-left: 1em

.o-action__cta
  & &--item
    display: block
    line-height: 1
    +transition

    +mouseover
      opacity: 0.6

    > .img
      height: 100%
      display: block
</style>
